import $ from '../$';
import { isDocument, isFunction, isString, isWindow } from '../utils';
import './each';

$.fn.is = function (selector) {
  let isMatched = false;

  if (isFunction(selector)) {
    this.each((index, element) => {
      if (selector.call(element, index, element)) {
        isMatched = true;
      }
    });
    return isMatched;
  }

  if (isString(selector)) {
    this.each((_, element) => {
      if (isDocument(element) || isWindow(element)) {
        return;
      } // @ts-ignore


      const matches = element.matches || element.msMatchesSelector;

      if (matches.call(element, selector)) {
        isMatched = true;
      }
    });
    return isMatched;
  }

  const $compareWith = $(selector);
  this.each((_, element) => {
    $compareWith.each((_, compare) => {
      if (element === compare) {
        isMatched = true;
      }
    });
  });
  return isMatched;
};